import { render, staticRenderFns } from "./ConfigCategoriesModal.vue?vue&type=template&id=772a6d04"
import script from "./ConfigCategoriesModal.vue?vue&type=script&lang=js"
export * from "./ConfigCategoriesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports